import api from '../../../api/index'

export function invoiceHistory() {
  return api.get(`getInvoiceHistory`);
}
export function creditNoteHistory() {
    return api.get(`getCreditNoteHistory`);
  }

export function generateCreditNote(payload) {
  return api.post("generateCreditNoteURL", payload);
}

export function generateInvoice(payload){
    return api.post('generateInvoiceURL', payload)
}

export function uploadInvoice(payload){
    return api.put('generateBulkInvoiceURLS', payload)
}
export function uploadCreditNote(payload){
    return api.put('generateBulkCreditNoteURLS', payload)
}

export function downloadInvoice(payload){
    return api.post("downloadInvoiceReport", payload)
}
export function invoiceUrl(payload){
  return api.post("getInvoiceURL", payload);
}

export function downloadInvoiceURL(payload){
  return api.post("downloadInvoiceURL", payload);
}




